// src/MetaPixelRouteTracking.jsx
import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { trackPageView } from "./pixel.js";

export default function MetaPixelRouteTracking() {
  const location = useLocation();

  useEffect(() => {
    trackPageView();
  }, [location.pathname, location.search]);

  return null;
}
